module.exports = __webpack_public_path__ + "img/tumor.2317312d.png";